document.addEventListener('DOMContentLoaded', () => {
  // Herokaruselli
  const carousels = document.querySelectorAll('section.herokaruselli');
  carousels.forEach((carousel) => {
    const images = carousel.querySelectorAll('img');
    if (images.length <= 1) return;
    let currentIndex = 0;
    const INTERVAL = 7000;
    images.forEach((img, index) => {
      if (index === 0) {
        img.classList.add('is-active');
      }
    });
    setInterval(() => {
      const current = images[currentIndex];
      currentIndex = (currentIndex + 1) % images.length;
      const next = images[currentIndex];

      current.classList.remove('is-active');
      next.classList.add('is-active');
    }, INTERVAL);
  });
  // /Herokaruselli

  // Referenssit filtteröinti
  const filterButtons = document.querySelectorAll('.reference-filter__item');
  const cards = document.querySelectorAll('.referenssi');
  filterButtons.forEach(button => {
    button.addEventListener('click', function () {
      const filter = this.dataset.filter;
      // aktiivinen nappi
      filterButtons.forEach(btn => btn.classList.remove('is-active'));
      this.classList.add('is-active');
      cards.forEach(card => {
        const cardTerms = card.dataset.kategoriat
          ? card.dataset.kategoriat.split(' ')
          : [];
        if (filter === 'all' || cardTerms.includes(filter)) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
  // /Referenssit filtteröinti
});

document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target); // animaatio vain kerran
        }
      });
    },
    {
      threshold: 0, // kuinka paljon pitää näkyä
      rootMargin: '0px 0px -10% 0px'
    }
  );
  reveals.forEach(el => observer.observe(el));
});

(function () {
  const svgs = document.querySelectorAll('.scroll-path-svg');
  const body = document.body;
  const STICKY_LIMIT = 107;
  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }
  function handleSticky() {
    if (window.scrollY > STICKY_LIMIT) {
      body.classList.add('sticky-header');
    } else {
      body.classList.remove('sticky-header');
    }
  }
  function onScroll() {
    const viewportHeight = window.innerHeight;
    // Sticky header
    handleSticky();
    // SVG scroll animaatio
    svgs.forEach(svg => {
      const rect = svg.getBoundingClientRect();
      const textPath = svg.querySelector('.scroll-text-path');
      if (!textPath) return;
      const start = parseFloat(svg.dataset.start || 0);
      const end   = parseFloat(svg.dataset.end || 100);
      const progress =
        (viewportHeight - rect.top) /
        (viewportHeight + rect.height);
      const clamped = clamp(progress, 0, 1);
      const offset = start + (end - start) * clamped;
      textPath.setAttribute('startOffset', offset + '%');
    });
    // Tunnuslukujen tekstin pystysuuntainen scroll-liike
    const statTexts = document.querySelectorAll('section.tunnusluvut .luku');
    statTexts.forEach(item => {
      const text = item.querySelector('.teksti');
      if (!text) return;
      const rect = item.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress =
        (viewportHeight - rect.top) /
        (viewportHeight + rect.height);
      const clamped = clamp(progress, 0, 1);
      // liikematka px (säädä tätä)
      const moveAmount = 220;
      const translateY = (1 - clamped) * moveAmount - moveAmount / 2;
      text.style.transform = `translate(-50%, calc(-50% + ${translateY}px))`;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll(); // initial call (myös sticky tarkistus)
})();

// Mobiili valikko
document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('button.hamburger');
  const nav = document.querySelector('nav.main-navi');
  const body = document.body;
  if (!hamburger || !nav) return;
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('open');
    body.classList.toggle('navi-open');
    const isOpen = body.classList.contains('navi-open');
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    // Halutessa myös naville oma luokka (helpottaa CSS:ää)
    nav.classList.toggle('is-open', isOpen);
  });
});